import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ContractAlert } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/ContractAlert';
import { Activities } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/{components}/Activities';
import { Comments } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/{components}/Comments';
import { PaymentTasks } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/{components}/PaymentTasks';
import { ProjectSummary } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/{components}/ProjectSummary';
import { PurchaseOrderContractTasks } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/{components}/PurchaseOrderContractTasks';
import { RelatedProjects } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/{components}/RelatedProjects';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { RenewedPurchaseOrders } from '@/features/w/[identifier]/teams/[team_id]/purchase_orders/[purchase_order_id]/{components}/RenewedPurchaseOrders';

export const TeamPurchaseOrder = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_, _t_ } = useCurrentTeamMember();

  useEffect(() => setTitle(`プロジェクト（費用）詳細`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        {
          label: `プロジェクト（費用） - ${_t_!.name}`,
          path: `/w/${_w_!.identifier}/teams/${_t_!.id}/purchase_orders`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <ContractAlert />

        <div className="row mb-4">
          <div className="col-12 col-lg-5">
            <ProjectSummary />

            <PaymentTasks />

            <PurchaseOrderContractTasks />

            <Activities />
          </div>
          <div className="col-12 col-lg-7">
            <Comments />

            <RelatedProjects />

            <RenewedPurchaseOrders />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
